import React from "react";
import styled from "styled-components";
import StatusLabel from "../StatusLabel";
import ActivityTimestamp from "./ActivityTimestamp";
import { userDisplayName } from "../../utils/helpers";
import {
  COMMENT_AVATAR_SIZE as AVATAR_SIZE,
  COMMENT_AVATAR_PADDING as AVATAR_PADDING
} from "../../settings/metrics";
import * as colors from "../../settings/colors";

const Timestamp = styled(ActivityTimestamp)`
  color: ${colors.TAB_TEXT};
  font-size: 13px;
  line-height: 24px;
`;

const StatusChangeWrapper = styled.div`
  display: flex;
  margin: 8px 0 8px ${AVATAR_SIZE + AVATAR_PADDING}px;
`;

const StatusMessage = styled.div`
  flex: 1;
  line-height: 24px;
  padding-right: 14px;
`;

const StatusChange = ({ activity }) => (
  <StatusChangeWrapper>
    <StatusMessage>
      {userDisplayName(activity.actor.name)} changed the status to{" "}
      <StatusLabel status={activity.details.toStatus} />
      {activity.details.toStatus === "on_hold" && (
        <React.Fragment>
          <br />
          <b>Hold Type:</b> {activity.details.holdType}
          <br />
          <b>Hold Reason:</b> {activity.details.holdReason}
        </React.Fragment>
      )}
    </StatusMessage>
    <Timestamp>{activity.createdAt}</Timestamp>
  </StatusChangeWrapper>
);

export default StatusChange;



// WEBPACK FOOTER //
// ./src/components/activities/StatusChange.js